var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconTick = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1163.000000, -142.000000)",
    fill: "currentColor",
    className: "tick"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1143.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,16 C16,16.2167474 15.9302226,16.4173888 15.8125543,16.5811823 C15.6635455,16.7903866 15.4370735,16.9389951 15.1739825,16.9849883 C15.118152,16.9948912 15.0610799,17 15.0029699,17 L8.99703014,17 C8.4463856,17 8,16.5561352 8,16 C8,15.4477153 8.45303631,15 8.99703014,15 L14,15 L14,4.00684547 C14,3.45078007 14.4438648,3 15,3 C15.5522847,3 16,3.44994876 16,4.00684547 L16,16 Z",
    transform: "translate(12.000000, 10.000000) rotate(45.000000) translate(-12.000000, -10.000000) "
  }))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconTick);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-tick.a3789967cb570ed3b49b41e5f51ead06.svg";